<script>
export default {
  name: 'SearchBox',
  props: {
    placeholder: {
      type: String,
      default: '请输入内容',
    },
    size: {
      type: String,
      default: 'small', // mini, small, large
    },
    value: {
      type: String,
      default: '',
    },
    search: Function,
  },
  data() {
    return {
      keyword: '',
      timer: null,
    };
  },
  watch: {
    keyword() {
      this.onSearch();
    },
    value() {
      this.keyword = this.value;
    },
  },
  methods: {
    onSearch() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.search(this.keyword.trim());
      }, 300);
    },
    onClear() {
      this.keyword = '';
      this.onSearch();
    },
  },
};
</script>

<template lang="pug">
el-input(v-model="keyword" :size="size" :placeholder="placeholder", @keyup.enter="onSearch")
  el-button(slot="append" icon="el-icon-search", @click="onSearch")
  .clear(slot="suffix" @click="onClear", v-if="keyword")
    i.el-icon-circle-close
</template>

<style lang="stylus" scoped>
.el-input
  width 360px
  position relative
  &:hover
    color #20A0FF
  .clear
    height 100%
    display flex
    align-items center
    font-size 14px
    color #bfbfbf
    cursor pointer
</style>



// WEBPACK FOOTER //
// SearchBox.vue?128977df